import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Loader } from "@googlemaps/js-api-loader";
import { environment } from '../../../../environments/environment';
import { FALSE } from '../../../utils/config/const';




@Component({
  selector: 'app-choice-positionmap-modal',
  templateUrl: './choice-positionmap-modal.component.html',
  styleUrls: ['./choice-positionmap-modal.component.css']
})
export class ChoicePositionmapModalComponent implements OnInit {


  //https://developers.google.com/maps/documentation/javascript/examples/programmatic-load-button

  @Input() name_store: string = "";
  @Input() dealer_store: string = "";
  @Input() zoom: number = 14;
  @Input() lat: number = 0;
  @Input() lng: number = 0;


  baseUrlAssetMarkerFolder = "/assets/images/markers/";
  storeCategoryDealerMarkerImage = {
    FW_POINTS: "marker_grigio_small.png",
    STANDARD_LOW: "marker_giallo_grigio_small.png",
    MONOBRAND: "marker_grigio_small.png",
    EXCELLENT: "marker_grigio_small.png",
    MASTER: "marker_giallo_small.png",
    FRANCHISING: "marker_giallo_small.png",
    GDS: "marker_grigio_small.png",
    STANDARD: "marker_grigio_small.png"
  }
  defaultMarkerImage: string = "marker_grigio_small.png";
  isButtonSaveDisabled: boolean = true;
  loader = new Loader({
    apiKey: environment.google.apikeymaps,
    version: "weekly",
    libraries: ["places"]
  });


  public geocoder: any;
  public map: any;
  public marker: any;
  public mapOptions = {};
  public mapMarkerOptions = {};
  public markerImage: string = "";
  //Centro iniziale
  public center = {
    lat: 0,
    lng: 0
  };
  //Centro attuale
  public actualCenter = {
    lat: 0,
    lng: 0
  };
  actualAddress: string = "";
  isDragging: boolean = false
  positionChanged: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.isButtonSaveDisabled = true;
    this.setCenter(this.lat, this.lng);
    this.setActualCenter(this.lat, this.lng);
    this.initMap();
  }

  setCenter(lat: any, lng: any) {
    this.center = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    }
  }
  setActualCenter(lat: any, lng: any) {
    this.actualCenter = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    }
  }

  isChangePosition() {
    let res = false;
    if (this.actualCenter.lat !== this.center.lat || this.actualCenter.lng !== this.center.lng) {
      res = true;
      this.isButtonSaveDisabled = false;
    } else {
      this.isButtonSaveDisabled = true;
    }
    return res;
  }

  getMapOptions(google) {
    return {
      center: this.actualCenter,
      zoom: this.zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      scaleControl: true,
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      fullscreenControl: true,
    };
  }

  getMarkerImage(categoryDealer: string) {
    let image = this.defaultMarkerImage;
    if (categoryDealer !== null && typeof categoryDealer !== typeof undefined) {
      categoryDealer = categoryDealer.replace(" ", "_");
      if (this.storeCategoryDealerMarkerImage.hasOwnProperty(categoryDealer)) {
        image = this.storeCategoryDealerMarkerImage[categoryDealer];
      }
    }
    return this.baseUrlAssetMarkerFolder + image;
  }

  getMapMarkerOptions() {
    return {
      position: this.actualCenter,
      map: this.map,
      icon: {
        url: this.markerImage,
        scaledSize: {
          width: 42,
          height: 60
        }
      },
      draggable: true
    }
  }



  initMap() {
    // Promise
    this.loader
      .load()
      .then((google) => {
        console.log("ok");
        console.log(google);

        /*  Inizializzo il geocoder */
        this.geocoder = new google.maps.Geocoder();
        /*  Inizializzo Mappa */
        this.mapOptions = this.getMapOptions(google);
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        /*  Inizializzo Marker */
        this.markerImage = this.getMarkerImage(this.dealer_store);
        this.mapMarkerOptions = this.getMapMarkerOptions();
        this.marker = new google.maps.Marker(this.mapMarkerOptions);

        let that = this;

        //Listener per il marker
        google.maps.event.addListener(
          this.marker,
          'dragstart',
          function () {
            console.log('dragstart');
          }
        );

        google.maps.event.addListener(
          this.marker,
          'drag',
          function () {
            this.isDragging = true; //Variabile di controllo
          }
        );


        google.maps.event.addListener(
          this.marker,
          'dragend',
          function () {
            this.isDragging = false;
            that.handleMarkerChange();
          }
        );

        google.maps.event.addListener(
          this.marker,
          'position_changed',
          function () {
            let position = that.marker.getPosition();
            that.setActualCenter(position.lat(), position.lng());
            that.setActualAddressMarker();
          }
        );
        // Configure the click listener.
        this.map.addListener("click", (mapsMouseEvent) => {
          console.log(mapsMouseEvent);
          console.log(mapsMouseEvent.latLng.toJSON());
        });

        this.setActualAddressMarker();

      })
      .catch(e => {
        console.log("error");
        // do something
      });
  }



  /**
   * Funzione che gestisce il cambio di posizione del marker
   */
  handleMarkerChange() {
    if ((!this.isDragging)) {
      let position = this.marker.getPosition();
      this.setActualCenter(position.lat(), position.lng());
      this.map.setCenter(position);
      let that = this;
      this.geocoder.geocode(
        { location: position },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            let result = results[0];
            let address = result.formatted_address;
            that.actualAddress = address;
          } else {
            alert(that.parseGeocoderStatus(status));
          }
        }
      );
      this.isChangePosition();
    }
  }

  setActualAddressMarker() {
    let position = this.marker.getPosition();
    let that = this;
    this.geocoder.geocode(
      { location: position },
      function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          let result = results[0];
          let address = result.formatted_address;
          that.actualAddress = address;
        } else {
          alert(this.parseGeocoderStatus(status));
        }
      }
    );
  }






  parseGeocoderStatus(status) {
    let msg = status;
    switch (status) {
      case google.maps.GeocoderStatus.ERROR:
        msg = 'There was a problem contacting the Google servers.';
        break;
      case google.maps.GeocoderStatus.INVALID_REQUEST:
        msg = 'Invalid request.';
        break;
      case google.maps.GeocoderStatus.OVER_QUERY_LIMIT:
        msg = 'The webpage has gone over the requests limit in too short a period of time.';
        break;
      case google.maps.GeocoderStatus.REQUEST_DENIED:
        msg = 'The webpage is not allowed to use the geocoder.';
        break;
      case google.maps.GeocoderStatus.UNKNOWN_ERROR:
        msg = 'A geocoding request could not be processed due to a server error. The request may succeed if you try again.';
        break;
      case google.maps.GeocoderStatus.ZERO_RESULTS:
        msg = 'No result was found.';
        break;
    }
    return msg;
  }


  geocodeAddress(address) {
    this.geocoder.geocode(
      { address: address },
      function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          let result = results[0];
          let position = result.geometry.location;
          if (this.map)
            this.map.fitBounds(result.geometry.viewport);

          this.setActualCenter(position.lat(), position.lng());
          this.map.setCenter(position);
        }
        else {
          alert(this.parseGeocoderStatus(status));
        }
      }
    )



  }





















  clickButtonSave() {
    if (this.isButtonSaveDisabled == FALSE) {
      this.activeModal.close(this.actualCenter);
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

}
